export function intersectSounds(set1, set2) {
    let z = new Set([...set1].filter(x => set2.has(x)));
    return z;
}
